import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from 'src/app/shared/components/layout/layout.component';
import { SmartUploadComponent } from './smart-upload.component';

const routes: Routes = [{ 
  path: '', 
  component: LayoutComponent ,
  children: [
    {
      path: '',
      component: SmartUploadComponent
    }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SmartUploadRoutingModule { }